import React from "react";
import PropTypes from "prop-types";
import ClipLoader from "react-spinners/ClipLoader";
import { Box } from "@material-ui/core";

export const Loading = ({ loading }) => {
  return (
    <Box
      display="flex"
      width="100%"
      height="100%"
      justifyContent="center"
      alignItems="center"
      mt={12}
    >
      <ClipLoader color="#E00000" loading={loading} size={90} />
    </Box>
  );
};

Loading.propTypes = {
  loading: PropTypes.bool.isRequired,
};

Loading.defaultProps = {
  loading: false,
};
